// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2026project/q2/2026word_cup/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
/**
 * 
 * {
  "code": 200,
  "msg": "获取成功",
  "data": [
    {
      "group": "A",
      "name": "墨西哥",
      "sort": "1",
      "points": "0",
      "group_rank": "1"
    },
    {
      "group": "A",
      "name": "南非",
      "sort": "2",
      "points": "0",
      "group_rank": "1"
    },
    {
      "group": "A",
      "name": "韩国",
      "sort": "3",
      "points": "0",
      "group_rank": "1"
    },
    {
      "group": "A",
      "name": "捷克",
      "sort": "4",
      "points": "0",
      "group_rank": "1"
    },
    {
      "group": "B",
      "name": "加拿大",
      "sort": "1",
      "points": "0",
      "group_rank": "1"
    },
    {
      "group": "B",
      "name": "波黑",
      "sort": "2",
      "points": "0",
      "group_rank": "1"
    },
    {
      "group": "B",
 */
const getList = () => {
  return http.get(`${urlPrefix}item-list`);
};

/**
 * 
 * 
 * 
 * 
 * {
  "code": 200,
  "msg": "获取成功",
  "data": [
    {
      "id": "2",
      "session": "1",
      "item_one": "3",
      "item_two": "4",
      "match_date": "1780886702",
      "item_one_points": null,
      "item_two_points": null,
      "item_one_name": "韩国",
      "item_two_name": "捷克",
      "session_name": "决赛",
      "match_date_text": "2026-06-08 10:45:02"
    },
    {
      "id": "1",
      "session": "1",
      "item_one": "1",
      "item_two": "2",
      "match_date": "1780888777",
      "item_one_points": null,
      "item_two_points": null,
      "item_one_name": "墨西哥",
      "item_two_name": "南非",
      "session_name": "决赛",
      "match_date_text": "2026-06-08 11:19:37"
    }
  ]
}
*/
const getxiaozusai = () => {
  return http.get(`${urlPrefix}knockout-stage`);
};
/**
 * "data": [
    {
      "id": "11",
      "name": "海地",
      "points": "10"
    },
    {
      "id": "10",
      "name": "摩洛哥",
      "points": "9"
    },
    {
      "id": "8",
      "name": "瑞士",
      "points": "8"
    },
    {
      "id": "9",
      "name": "巴西",
      "points": "8"
    },
*/
const getRankData = () => {
  return http.get(`${urlPrefix}rank`);
};
export { getBaseInfo, getxiaozusai, getList, getRankData };
